






































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapMutations } from 'vuex';

import { BaseResponseDTO } from '@/types';
import { resetObjectIds } from '@/utils';
import 'maz-ui/lib/css/base.css';

@Component({
  methods: {
    ...mapMutations([
      'setFakerList'
    ])
  }
})
export default class App extends Vue {
  private createDialogVisible = false;
  private editDialogVisible = false;
  private newItemName = '';
  private newItemType = '';
  private selectedItemType = 'array';
  private propertyTypeOptions: any = [
    { label: 'Array', value: 'array' },
    { label: 'Object', value: 'object' }
  ];

  private editItemName = '';
  private editType = '';
  private isLoading = false;
  private activeCollapse: string[] = [];
  private hasLeftSidebarOpen = true;
  setFakerList!: () => any;

  created () {
    this.$store.dispatch('getSettings');
    this.$store.dispatch('getModels');
    this.$store.dispatch('getEndpoints');
    this.$store.dispatch('getEndpoints');
    this.setFakerList();

    if (Object.keys(this.$route.params).length) {
      this.activeCollapse.push(this.$route.params.type);
    }
  }

  get endpoints (): BaseResponseDTO {
    return this.$store.state.endpoints;
  }

  get models (): BaseResponseDTO {
    return this.$store.state.models;
  }

  get settings (): any {
    return this.$store.state.settings;
  }

  setnewItemName (newItemName: string) {
    this.newItemName = newItemName;
  };

  openNewItemDialog (type: string) {
    this.createDialogVisible = true;
    this.newItemType = type;
    this.$nextTick(() => {
      (this.$refs.createInput as any).focusInput();
    });
  }

  async duplicate (itemName: string, itemType: string) {
    const duplicate = resetObjectIds(Vue.prototype.$lodash.cloneDeep((this as any)[itemType][itemName]));
    const numberOfDuplicates = Object.keys((this as any)[itemType]).filter((x: string|string[]) => x.includes(itemName)).length;

    const newItemName = `${itemName}-copy${numberOfDuplicates > 1 ? numberOfDuplicates : ''}`;

    try {
      await this.$store.dispatch('duplicateEntry', {
        type: itemType,
        id: newItemName,
        payload: duplicate
      }).then(() => {
        this.$router.push(`/${itemType}/${newItemName}`);
      });
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex);
      this.$notify({
        title: 'Warning',
        text: 'An error happened. Please check the console',
        type: 'warning'
      });
    }
  }

  openEditItemDialog (itemName: string, itemType: string) {
    this.editDialogVisible = true;
    this.editItemName = itemName;
    this.newItemName = itemName;
    this.editType = itemType;
    this.$nextTick(() => {
      (this.$refs.editInput as any).focusInput();
    });
  }

  async editEntry () {
    this.editDialogVisible = false;
    await this.$store.dispatch('editEntry', {
      type: `${this.editType}s`,
      name: this.editItemName,
      newName: this.newItemName
    }).then(() => {
      this.$notify({
        title: `${this.editItemName} has been renamed`,
        text: '',
        type: 'success'
      });
      if (this.$route.params.id === this.editItemName) {
        this.$router.push(`/${this.editType}/${this.newItemName}`);
      }
    });
  };

  createNewItem () {
    this.createDialogVisible = false;
    this.$store.dispatch('createNewItem', {
      type: this.newItemType,
      propertyType: this.newItemType === 'endpoint' ? this.selectedItemType : 'model',
      name: this.newItemName
    });
  };

  resetDialogState () {
    this.editItemName = '';
    this.newItemName = '';
    this.selectedItemType = 'array';
    this.newItemType = '';
    this.editType = '';
  }

  async deleteEntry () {
    this.isLoading = true;
    await this.$store.dispatch('deleteEntry', {
      type: `${this.editType}s`,
      name: this.editItemName
    }).then(() => {
      this.$notify({
        title: `${this.editItemName} has been deleted`,
        text: '',
        type: 'success'
      });
      if (this.$route.params.id === this.editItemName) {
        this.$router.push('/');
      }
      this.isLoading = false;
      this.editDialogVisible = false;
    });
  }

  setCollapseItem (item: string): void {
    const itemIndex = this.activeCollapse.indexOf(item);
    if (itemIndex !== -1) {
      this.activeCollapse.splice(itemIndex, 1);
    } else {
      this.activeCollapse.push(item);
    }
  }
};
